(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-carousel')) {
    class VideoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.autoplay = this.dataset.autoplay === 'true';

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.prev());
        if (next) next.addEventListener('click', () => this.next());
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) {
            video.muted = true;
            video.playsInline = true;
          }
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('video');
              if (!video) return;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                if (this.autoplay) video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { root: this.track, threshold: [0, 0.6, 1] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.setupAutoScroll();
        this.update();
      }

      setupAutoScroll() {
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const wanted = this.dataset.autoScroll === 'true' && !reduce;
        this.loopWidth = 0;
        if (!wanted || this.slides.length < 2) return;
        const t = this.track;
        // Only roll when the videos do not all fit on screen at once.
        if (t.scrollWidth <= t.clientWidth + 4) return;

        this.dataset.auto = 'true';
        this.loopWidth = this.step() * this.slides.length;
        this.slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.removeAttribute('data-slide');
          clone.setAttribute('aria-hidden', 'true');
          const v = clone.querySelector('video');
          if (v) {
            v.muted = true;
            v.playsInline = true;
            v.setAttribute('tabindex', '-1');
          }
          t.appendChild(clone);
          this.observer.observe(clone);
        });

        this.speed = Math.max(5, Number(this.dataset.scrollSpeed) || 25);
        this.pos = t.scrollLeft;
        this.holdUntil = 0;
        this.running = false;
        this.inView = true;
        const hold = (ms) => { this.holdUntil = performance.now() + ms; };
        this.addEventListener('mouseenter', () => hold(1e9));
        this.addEventListener('mouseleave', () => hold(800));
        this.addEventListener('touchstart', () => hold(1e9), { passive: true });
        this.addEventListener('touchend', () => hold(2500), { passive: true });
        this.addEventListener('focusin', () => hold(1e9));
        this.addEventListener('focusout', () => hold(800));
        this.addEventListener('wheel', () => hold(2500), { passive: true });

        this.viewObserver = new IntersectionObserver((es) => {
          this.inView = es[0].isIntersecting;
          if (this.inView) this.startLoop();
        });
        this.viewObserver.observe(this);
        this.startLoop();
      }

      startLoop() {
        if (this.running || !this.loopWidth) return;
        this.running = true;
        let last = performance.now();
        const tick = (now) => {
          if (!this.isConnected || !this.inView) { this.running = false; return; }
          const dt = Math.min(now - last, 100);
          last = now;
          const t = this.track;
          if (now >= this.holdUntil && !document.hidden) {
            // If the visitor moved it (swipe / arrows), continue from there.
            if (Math.abs(t.scrollLeft - this.pos) > 2) this.pos = t.scrollLeft;
            this.pos += (this.speed * dt) / 1000;
            if (this.pos >= this.loopWidth) this.pos -= this.loopWidth;
            t.scrollLeft = this.pos;
          } else {
            this.pos = t.scrollLeft;
          }
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
      }

      step() {
        if (this.slides.length < 2) return this.track.clientWidth;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      next() {
        const t = this.track;
        if (this.loopWidth) {
          if (t.scrollLeft >= this.loopWidth) t.scrollLeft -= this.loopWidth;
          t.scrollBy({ left: this.step(), behavior: 'smooth' });
          return;
        }
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) t.scrollTo({ left: 0, behavior: 'smooth' });
        else t.scrollBy({ left: this.step(), behavior: 'smooth' });
      }

      prev() {
        const t = this.track;
        if (this.loopWidth) {
          if (t.scrollLeft < this.step()) t.scrollLeft += this.loopWidth;
          t.scrollBy({ left: -this.step(), behavior: 'smooth' });
          return;
        }
        if (t.scrollLeft <= 4) t.scrollTo({ left: t.scrollWidth, behavior: 'smooth' });
        else t.scrollBy({ left: -this.step(), behavior: 'smooth' });
      }

      go(index) {
        const i = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
      }

      update() {
        const t = this.track;
        const offset = this.loopWidth ? t.scrollLeft % this.loopWidth : t.scrollLeft;
        const index = Math.round(offset / this.step()) % this.slides.length;
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('video-carousel', VideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
